import script from "./TutorBankInfoForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorBankInfoForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorBankInfoForm.vue?vue&type=style&index=0&id=ae5e01a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae5e01a0"]])

export default __exports__